import { render, staticRenderFns } from "./Integracao.vue?vue&type=template&id=4427d6c8"
import script from "./Integracao.vue?vue&type=script&lang=js"
export * from "./Integracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports